import { useEffect, useState } from 'react';
import { get } from 'unified-navigation-ui/utils/tempStorage';
import { usePortal, useUser } from './useNavConfig';
import { apiClientWithMiddleware } from '../utils/API';
import { getProductTier } from '../utils/getProductTier';
import { HELP_NOTIFICATION_DISPLAY_TYPE, trackHelpNotificationDisplay } from '../components/GlobalToolbar/utils/trackHelpNotification';
import { captureException } from '../utils/sentryAPI';
import { HAS_OPENED_WIDGET_OR_DISMISSED_TOOLTIP_KEY } from '../external-contrib/in-app-help/constants/tooltips';
import { isSeleniumRunning } from '../utils/testEnv';
export const fetchHelpNotifications = portalId => {
  return apiClientWithMiddleware().get(`helpdesk-integration/v1/notifications?portalId=${portalId}`);
};
export const getHelpNotification = (scopes, portalId) => {
  if (!scopes.includes('zorse-webticket')) {
    return Promise.resolve(false);
  }
  return fetchHelpNotifications(portalId).then(zorseResponse => {
    return zorseResponse.count > 0;
  }).catch(e => {
    console.error('Caught error from notifications request:', e);
    return false;
  });
};
export const useHelpNotification = () => {
  const [showNotification, setShowNotification] = useState(false);
  const {
    scopes,
    displayLanguage
  } = useUser();
  const {
    portalId
  } = usePortal();
  const productTier = getProductTier(scopes);
  const isProOrEnterprise = productTier === 'enterprise' || productTier === 'pro';
  const isEnglish = displayLanguage && displayLanguage.includes('en');
  useEffect(() => {
    const isHelpWidgetOpenedBefore = get(HAS_OPENED_WIDGET_OR_DISMISSED_TOOLTIP_KEY) || isSeleniumRunning();
    if (!isHelpWidgetOpenedBefore && isProOrEnterprise && isEnglish) {
      setShowNotification(true);
    } else {
      getHelpNotification(scopes, portalId).then(value => {
        if (value) {
          setShowNotification(true);
          trackHelpNotificationDisplay(HELP_NOTIFICATION_DISPLAY_TYPE.RECEIVE_NOTIFICATION);
        }
      }).catch(captureException);
    }
  }, [setShowNotification, scopes, portalId, isProOrEnterprise, isEnglish]);
  useEffect(() => {
    const handleHelpMessage = event => {
      let message;
      try {
        message = typeof event.data === 'object' ? event.data : JSON.parse(event.data);
      } catch (e) {
        if (window.hubspot &&
        // @ts-expect-error - No zorse type in the hubspot window object
        window.hubspot.zorse &&
        // @ts-expect-error - No zorse type in the hubspot window object
        window.hubspot.zorse.dev) {
          console.error('Help button received an unparsable postMessage:', e, event);
        }
        return;
      }
      if (message && message.name === 'chat-message' && document.querySelector('html.zorse-opened') === null) {
        setShowNotification(true);
        trackHelpNotificationDisplay(HELP_NOTIFICATION_DISPLAY_TYPE.RECEIVE_CHAT_MESSAGE);
      }
    };
    window.addEventListener('message', handleHelpMessage);
    return () => {
      window.removeEventListener('message', handleHelpMessage);
    };
  }, [showNotification]);
  return [showNotification, setShowNotification];
};